import {Image, message, Switch} from "antd";
import {SActionBtn, SLowcodeList, SMessage, STableActions} from "shj-components";
import {config} from "./config.tsx";
import EditContent from "./edit.tsx";
import {useSetState} from "ahooks";
import {tableApiFunc} from "@/utils/data.ts";
import {
    deleteMemberEquity,
    queryMemberEquityCategoryList,
    queryMemberEquityListByPage,
    updateStateMemberEquity
} from "@/services/member.ts";
import {useRef} from "react";

/**
 *
 * 会员权益库
 * @constructor
 */
function Page() {


    const [state, setState] = useSetState({open: false, data: null});

    const tableRef = useRef<any>()
    const onChangeStatus = (checked, id) => {

        SMessage.confirm({
            title: checked ? '启用操作' : '禁用操作',
            content: `确定继续操作吗？`,
            onOk: async () => {
                try {
                    await updateStateMemberEquity({id, state: checked})
                    tableRef.current.reload()
                } catch (e) {
                    console.log(e)
                }
            },
        })
    }

    const onDelete = (id) => {
        deleteMemberEquity({id}).then(() => {
            message.success('删除成功')
            tableRef.current.reload()
        })
    }
    const onAddOrEdit = (data?: any) => {
        setState({open: true, data: data});
    }
    const destroy = (success) => {
        setState({open: false})
        if (success) {
            tableRef.current.reload()
        }
    }
    const getStatusOptions = async () => {
        const equityCategoryList = await queryMemberEquityCategoryList({});

        return Promise.resolve({
            stateList: [{label: '启用', value: true}, {label: '停用', value: false},],
            equityCategoryList
        })
    }
    const extensions = {
        request: {
            fetchList: tableApiFunc(queryMemberEquityListByPage, {
                paginationInBody: true,
                fieldNames: {current: 'current'},
            }),
            getStatusOptions,
        },
        events: {onAdd: () => onAddOrEdit({})},
        customRender: {
            switchRender(v: boolean, record: Record<string, any>) {
                return <Switch checked={v} onClick={(checked) => onChangeStatus(checked, record.id)}/>
            },
            iconRender(v: string) {
                return <Image style={{width: 60, height: 50, objectFit: 'contain'}} src={v}/>
            },
            actionRender(_: null, record: Record<string, any>) {
                return (
                    <STableActions>
                        <SActionBtn disabled={record.state} onClick={() => onAddOrEdit(record)}>编辑</SActionBtn>
                        <SActionBtn disabled={record.state} isDelete onClick={() => onDelete(record.id)}>删除</SActionBtn>
                    </STableActions>
                )
            }
        }
    }
    return (
        <div>
            <div style={{display: 'flex'}}>
                <EditContent {...state} destroy={destroy}/>
                <SLowcodeList
                    searchMode={'group'}
                    config={config}
                    ref={tableRef}
                    {...extensions}
                />
            </div>
        </div>
    );
}

export default Page;
